/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function AIGovCampusSEO({ description, lang, meta, title }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            twitterImage
            facebookImage
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      /*titleTemplate={`%s | ${site.siteMetadata.title}`}*/
      titleTemplate={`%s`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `og:image`,
          content: site.siteMetadata.facebookImage,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:image`,
          content: site.siteMetadata.twitterImage,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      <link rel="stylesheet" href="//maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"></link>
      {/* <!-- Noscript content for added SEO --> */}
      <noscript>{`
        <a href="https://www.eventbrite.com/e/sng-live-speaker-series-ai-in-state-local-2021-registration-145093044201" rel="noopener noreferrer" target="_blank">
      `}</noscript>

      <script src="https://www.eventbrite.com/static/widgets/eb_widgets.js" type="text/javascript" />
      <script type="text/javascript">{`
          var exampleCallback = function() {
              console.log('Order complete!');
          };
          window.EBWidgets.createWidget({
              widgetType: 'checkout',
              eventId: '145093044201',
              modal: true,
              modalTriggerElementId: 'eventbrite-widget-modal-trigger-145093044201',
              onOrderComplete: exampleCallback
          });
      `}</script>
    </Helmet>
  )
}

AIGovCampusSEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

AIGovCampusSEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default AIGovCampusSEO